export default __webpack_public_path__ + "0b6e7e7857f859f68539afa0a8e41708.png";